import type { ShapeId, WallShape } from '@walls/store';

export function getShapeFrontZPos(shapes: WallShape[], shapeId: ShapeId) {
  const shape = shapes.find((currentShape) => currentShape.id === shapeId);

  if (!shape) {
    return null;
  }

  const currentZPos = shape.zPos ?? 0;
  const frontZPos = shapes.reduce(
    (highestZPos, currentShape) => Math.max(highestZPos, currentShape.zPos ?? 0),
    0
  );

  return currentZPos >= frontZPos ? currentZPos : frontZPos + 1;
}
